import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import Dropdown from '../Dropdown/Dropdown';
import Flag from '../Flag/Flag';

const HeaderTopLocale = ({ country }) => <li className="o-list-inline__item  c-header-top__item">
    <Dropdown
      btnClassName="c-header-top__link"
      className="c-header-dropdown"
      color="none"
      dropdownMenuClassName="c-header-dropdown__menu"
      id="headerLocaleDropdown"
      position="right"
      text={<Flag country={country} />}
    >
      <div className="c-header-dropdown__inner">
        <form className="c-form  c-form--small">
          <div className="c-form__element">
            <label className="c-form__label" htmlFor="headerSelectCountry">
              Choose country
            </label>
            <div className="c-form__control">
              <div className="c-select-container">
                <select
                  className="c-select"
                  id="headerSelectCountry"
                  defaultValue="us"
                >
                  <optgroup label="Asia-Pacific">
                    <option value="au">Australia</option>
                    <option value="cn">China</option>
                    <option value="hk">Hong Kong</option>
                    <option value="nz">New Zealand</option>
                    <option value="sg">Singapore</option>
                  </optgroup>
                  <optgroup label="North America">
                    <option value="ca">Canada</option>
                    <option value="us">United States</option>
                  </optgroup>
                  <optgroup label="Europe, the Middle East and Africa">
                    <option value="at">Austria</option>
                    <option value="be">Belgium</option>
                    <option value="dk">Denmark</option>
                    <option value="fi">Finland</option>
                    <option value="fr">France</option>
                    <option value="de">Germany</option>
                    <option value="it">Italy</option>
                    <option value="ie">Ireland</option>
                    <option value="nl">Netherlands</option>
                    <option value="no">Norway</option>
                    <option value="es">Spain</option>
                    <option value="se">Sweden</option>
                    <option value="ch">Switzerland</option>
                    <option value="gb">United Kingdom</option>
                    <option value="ue">US Software Enrollments</option>
                  </optgroup>
                </select>
              </div>
            </div>
          </div>
          <div className="c-form__element">
            <label className="c-form__label" htmlFor="headerSelectLanguage">
              Choose language
            </label>
            <div className="c-form__control">
              <div className="c-select-container  c-select-container--block">
                <select
                  id="headerSelectLanguage"
                  className="c-select"
                  defaultValue="en"
                >
                  <option value="de">Deutsch</option>
                  <option value="en">English</option>
                  <option value="es">Español</option>
                  <option value="fr">Français</option>
                  <option value="it">Italiano</option>
                  <option value="nl">Nederlands</option>
                  <option value="sv">Svenska</option>
                </select>
              </div>
            </div>
          </div>
          <Button color="primary" size="small" fullWidth>
            Go
          </Button>
        </form>
      </div>
    </Dropdown>
  </li>

export default HeaderTopLocale;

HeaderTopLocale.propTypes = {
  country: PropTypes.string.isRequired,
};
